import { ANALYTICS_DATALAYER_BRAND, ANALYTICS_DATALAYER_SITE_GENERATOR } from '../utils/constants'

type Props = { pageUrl: string; type: string; prov: string; lang: string }

export const setAnalyticsForPageView = ({ pageUrl, type, prov, lang }: Props): void => {
  if (!pageUrl) {
    window.dataLayer = {}
    return
  }
  const splitUrl = pageUrl.split('?')
  const pageName = splitUrl[0].substring(1)
  const [category, subCategory1] = pageName.split('/')

  const dataLayer = {
    page: {
      name: pageName,
      province: prov,
      language: lang,
      brand: ANALYTICS_DATALAYER_BRAND,
      siteGenerator: ANALYTICS_DATALAYER_SITE_GENERATOR,
      type,
      category,
      subCategory1,
    },
  }
  window.dataLayer = dataLayer
}

export const setAnalyticsEvent = (event: { action: string; name: string; details?: string }) => {
  if (window.dataLayer) {
    window.dataLayer.event = event
  }
}
